
<div class="nav-bar d-flex flex-column" style="height: var(--dvh, 100vh); overflow: hidden;">

  <!-- TOP TOOLBAR -->
      <mat-toolbar
      class="d-flex justify-content-between align-items-center px-3 custom-toolbar-shadow"
      [style.background-image]="toolbarBackgroundImage"
      [style.color]="useAltSidenav ? 'white' : 'rgb(37, 32, 97)'"
      style="z-index: 1001; padding: 0.5rem; flex-shrink: 0;">

    <div class="d-flex align-items-center">
      <img [src]="logo" alt="Logo"
           [style.height.px]="useAltSidenav ? 30 : 40"
           [style.width.px]="useAltSidenav ? 40 : 100"
           style="margin-right: 6px;">
      <span class="fw-bold fs-5">{{ companyText }}</span>
    </div>


    <div class="d-flex align-items-center gap-3">
      <img *ngIf="!useAltSidenav" [src]="secondaryLogo" alt="Secondary Logo"
           style="height: 60px; width: 150px; margin-right: 6px;">
      <div [style.color]="useAltSidenav ? 'white' : 'inherit'" style="font-weight: 500;">Welcome {{ username }}</div>

      <button mat-icon-button (click)="logout()" title="Logout"
              [style.color]="useAltSidenav ? 'white' : 'rgb(37, 32, 97)'">
        <mat-icon>logout</mat-icon>
      </button>
    </div>
  </mat-toolbar>

  <!-- MAIN LAYOUT -->
  <mat-sidenav-container class="flex-grow-1" style="overflow: hidden; position: relative;">

    <!-- SIDENAV -->
                    <mat-sidenav
                      [mode]="'side'"
                      [opened]="true"
                      class="sidenav transition-all duration-300 ease-in-out"
                      [style.background-color]="useAltSidenav ? '#000' : (secondaryColor2 || secondaryColor || '#97c6f9')"
                      [style.overflow]="'hidden'"
                      style="box-shadow: 4px 0 10px rgba(1,12,60,0.2);
                        z-index: 1000;"
                      [style.width.%]="isCollapsed ? 5 : 16">

      <div class="flex items-center justify-between px-3" style="padding-top: 24px; padding-bottom: 8px;">
        <button mat-icon-button (click)="toggleSidebar()"
          [style.color]="useAltSidenav ? 'white' : 'rgb(18,17,17)'">
          <mat-icon>menu</mat-icon>
        </button>
      </div>

      <!-- MENU -->
      <mat-nav-list>
        <ng-container *ngFor="let item of menuItems">

          <!-- NO CHILD -->
          <a mat-list-item
             *ngIf="!hasChildren(item)"
             class="menuItems flex items-center px-4"
             [routerLink]="item.path"
             [ngClass]="{'active-item': isActive(item)}"
             [ngClass]="{'justify-center': isCollapsed}"
             [matTooltip]="item.name"
             matTooltipPosition="right">

            <mat-icon [style.color]="useAltSidenav ? 'white' : 'black'" class="pt-2">
              {{ item.icon }}
            </mat-icon>

            <span [style.color]="useAltSidenav ? 'white' : 'black'" style="padding-left:20px; font-weight:500;"
                  [ngClass]="{'hidden': isCollapsed}">
              {{ item.name }}
            </span>
          </a>

          <!-- WITH CHILD -->
          <ng-container *ngIf="hasChildren(item)">
            <a mat-list-item
               class="menuItems flex items-center px-4"
               (click)="toggleSubmenu(item.name, $event)"
               [ngClass]="{'justify-center': isCollapsed}"
               [matTooltip]="item.name"
               matTooltipPosition="right">

              <mat-icon [style.color]="useAltSidenav ? 'white' : 'black'" class="pt-2">
                {{ item.icon }}
              </mat-icon>

              <span [style.color]="useAltSidenav ? 'white' : 'black'" style="padding-left:20px; font-weight:500;"
                    [ngClass]="{'hidden': isCollapsed}">
                {{ item.name }}
              </span>

              <mat-icon *ngIf="!isCollapsed && item.name !== 'Quotes'" style="margin-left:auto;"
                        [style.color]="useAltSidenav ? 'white' : 'black'">
                {{ isMenuExpanded(item.name) ? 'expand_less' : 'expand_more' }}
              </mat-icon>
            </a>

            <!-- CHILD LIST -->
            <div *ngIf="isMenuExpanded(item.name) && !isCollapsed">
              <ng-container *ngFor="let child of item.children">

                <!-- Child without grandchildren -->
                 <a mat-list-item
                   *ngIf="!hasChildren(child)"
                   class="menuItems child-menu px-4"
                   [routerLink]="child.path"
                   [ngClass]="{'active-item': isActive(child)}"
                   [matTooltip]="child.name"
                   matTooltipPosition="right">

                  <mat-icon [style.color]="useAltSidenav ? 'white' : 'black'" class="pt-2">
                    {{ child.icon }}
                  </mat-icon>

                  <span [style.color]="useAltSidenav ? 'white' : 'black'" style="padding-left:20px; font-weight:500;">
                    {{ child.name }}
                  </span>
                </a>

                <!-- Child with grandchildren -->
                <ng-container *ngIf="hasChildren(child)">
                  <a mat-list-item
                     class="menuItems child-menu px-4"
                     (click)="toggleSubmenu(child.name, $event)"
                     [matTooltip]="child.name"
                     matTooltipPosition="right">

                    <mat-icon [style.color]="useAltSidenav ? 'white' : 'black'" class="pt-2">
                      {{ child.icon }}
                    </mat-icon>

                    <span [style.color]="useAltSidenav ? 'white' : 'black'" style="padding-left:20px; font-weight:500;">
                      {{ child.name }}
                    </span>

                    <mat-icon *ngIf="child.name !== 'Manage Quotes'" style="margin-left:auto;"
                              [style.color]="useAltSidenav ? 'white' : 'black'">
                      {{ isMenuExpanded(child.name) ? 'expand_less' : 'expand_more' }}
                    </mat-icon>
                  </a>

                  <!-- Grandchild list -->
                  <div *ngIf="isMenuExpanded(child.name)" class="grandchild-menu">
                    <a mat-list-item
                       *ngFor="let grandchild of child.children"
                       class="menuItems grandchild-menu px-4"
                       [routerLink]="grandchild.path"
                       [ngClass]="{'active-item': isActive(grandchild)}"
                       [matTooltip]="grandchild.name"
                       matTooltipPosition="right">

                      <mat-icon [style.color]="useAltSidenav ? 'white' : 'black'" class="pt-2">
                        {{ grandchild.icon }}
                      </mat-icon>

                       <span [style.color]="useAltSidenav ? 'white' : 'black'" style="padding-left:40px; font-weight:500;">
                        {{ grandchild.name }}
                      </span>
                    </a>
                  </div>
                </ng-container>

              </ng-container>
            </div>

          </ng-container>

        </ng-container>
      </mat-nav-list>

      <!-- Alternate secondary logo pinned to bottom-left when alt sidenav is enabled -->
      <img *ngIf="useAltSidenav"
           [src]="secondaryLogo"
           alt="Secondary Logo"
           [style.position]="'absolute'"
           style="left: 2px; object-fit: contain; z-index: 1002; pointer-events: none;"
           [style.bottom.px]="isCollapsed ? 20 : 12"
           [style.width]="isCollapsed ? '90px' : '180px'"
           />

    </mat-sidenav>

    <!-- CONTENT -->
    <mat-sidenav-content
      class="bg-gray-100 transition-all duration-300 ease-in-out overflow-auto"
      [style.marginLeft.%]="isCollapsed ? 5 : 16">

      <div [style.margin]="isChatRoute ? '0' : '1.5rem'" style="height:100%;">
        <router-outlet></router-outlet>
      </div>
    </mat-sidenav-content>

  </mat-sidenav-container>
</div>
